import { Mic, MicOff } from '@mui/icons-material';
import { RoundButton } from '@ysura/common';

import { useInteraction } from '@/hooks';

type ToggleCameraButtonProps = {
  size?: 'large' | 'medium' | 'small';
};

export const ToggleMicButton = ({
  size = 'large',
}: ToggleCameraButtonProps) => {
  const { isMicActive, isMicAccessDisabled, toggleIsMicActive } =
    useInteraction();

  const toggleMic = () => {
    toggleIsMicActive();
  };

  return (
    <RoundButton
      size={size}
      variant="secondary"
      inactive={!isMicActive}
      disabled={isMicAccessDisabled}
      testId="mic-button"
      onClick={toggleMic}
    >
      {isMicAccessDisabled || !isMicActive ? <MicOff /> : <Mic />}
    </RoundButton>
  );
};
